<template>
    <div class="first_headerback_mian">
        <div class="fanicon">
            <img src="../../assets/Homeimg/lefticon.webp" alt="" @click="user_handoff(2)" />
            <div class="text_on">
                <slot name="title"></slot>
            </div>
        </div>
        <div class="chaicon" @click="Shutdown">
            <img src="../../assets/Homeimg/clonse.webp" alt="" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, defineProps } from 'vue'
const emit = defineEmits(["getValue"])
const props = defineProps({
    title: {
        type: String,
    },
})
const Shutdown = () => {
    emit("getValue", false)
}
const user_handoff = (num: number) => {
    emit("user_handoff", 2)
}
</script>

<style  lang="less" scoped>
.first_headerback_mian {
    width: 100%;
    height: 56px;
    // background: wheat;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
  
    margin-bottom: 60px;

    .text_on {
        min-width: 158px;
        min-height: 26px;
        color: white;
        font-size: 18px;
        display: flex;
        align-items: center;
    }

    .chaicon {
        width: 18px;
        height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition-duration: 0.2s;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .chaicon:hover {
        opacity: 0.7;
    }

    .chaicon:active {
        transform: scale(0.9);
    }

    .fanicon {
        display: flex;
        align-items: center;
        transition-duration: 0.2s;
        font-weight: bold;
 

        img {
            width: 11px;
            height: 20px;
            margin-right: 24px;
            transition-duration: 0.2s;
        }

        .img:hover {
            opacity: 0.7;
        }
    }
    .fanicon:active{

        img{
            transform: scale(0.9);
        }

    }


}
</style>